export const LOGIN = 'login';
export const OTP = 'otp';
export const APP = 'app';
export const NOT_FOUND = 'company-not-found';
export const PAGE_NOT_FOUND = 'page-not-found';
export const ENDED = 'ended';
export const ACCOUNT_SETTINGS = 'account-settings';
export const ACCOUNT_SETTINGS_TABS = 'app/account-settings';
export const ACCOUNT_SETTINGS_SURVAYS = 'account-settings/survays';
export const ACCOUNT_SETTINGS_NOTIFICATIONS = 'account-settings/notifications';
export const ACCOUNT_SETTINGS_RECEIPTS = 'account-settings/receipts';
export const ACCOUNT_DETAILS = 'account-details';
export const ACCOUNT_DETAILS_TABS = 'app/account-details';
export const PERSONAL_DETAILS = 'account/personal-details';
export const CHANGE_PASSWORD = 'account/change-password';
export const SIGNUP = 'sign-up';
export const MY_CARDS = 'my-cards';
export const PAYMENT_CARDS = 'payment-cards';
export const PAYMENT_CARDS_FULL = 'app/payment-cards';
export const LOYALTY_CARDS = 'loyalty-cards';
export const LOYALTY_CARDS_FULL = 'app/loyalty-cards';
export const MY_CARDS_TABS = 'app/my-cards';
export const SIGNUP_CONFIRMATION = 'sign-up/confirmation';
export const DEACTIVATE_ACCOUNT = 'account/deactivate';
export const PURCHASE_HISTORY = 'purchase-history';
export const PURCHASE_HISTORY_TABS = 'app/purchase-history';
export const LOYALTY = 'loyalty';
export const LOYALTY_TABS = 'app/loyalty';
export const LOYALTY_POINTS = 'loyalty-points';
export const LOYALTY_WALLET = 'wallet';
export const LOYALTY_WALLET_FULL = 'loyalty/wallet';
export const LOYALTY_WALLET_FULL_TABS = 'app/loyalty/wallet';
export const LOYALTY_VOUCHER = 'voucher';
export const LOYALTY_VOUCHER_FULL = 'loyalty/voucher';
export const LOYALTY_VOUCHER_FULL_TABS = 'app/loyalty/voucher';
export const LOYALTY_VOUCHER_INTEROGATION = 'voucher/interogation';
export const LOYALTY_WALLET_INTERROGATION = 'wallet/interrogation';
export const SELECT_APP = 'choose-function';
export const SELECT_APP_SIMPLE = 'choose-function';
export const SELECT_APP_SIMPLE_TABS = 'app/choose-function';
export const CHOOSE_LOCATION = 'choose-function/choose-location';
export const CHOOSE_LOCATION_TABS = 'app/choose-function/choose-location';
export const CHOOSE_MENU = 'choose-function/choose-menu';
export const CHOOSE_MENU_TABS = 'app/choose-function/choose-menu';
export const CHECKOUT_ORDER = 'choose-function/checkout-order';
export const PAYMENT_SUCCESS = 'choose-function/payment-success';
export const LOCATION_SELECTION = 'location-selection';
export const LOCATION_SELECTION_TABS = 'app/location-selection';
export const PAYMENT_CONFIRMATION = 'payment-confirmation';
export const SIDE_MENU = 'side-menu';
export const ADD_CARD = 'add-card';
export const SELECT_CARD = 'select-card';
export const TABS = 'tabs';
export const TABS_CC = 'tabs';
export const SELECT_PRODUCT = 'select-product';
export const TRANSACTION_TABS = 'transaction-tabs';
export const TRANSACTION_SUMMARY = 'transaction-summary';
export const CUSTOMER_GROUPS = 'customer-groups';
export const TERMS_AND_CONDITIONS = 'terms-and-conditions';
export const TRANSACTION_RECEIPT = 'receipt';
export const PAYMENTS = 'payments';
export const ABOUT = 'about';
export const FAQ = 'faq';
export const ACCESSIBILITY_STATEMENT = 'accessibility-statement';
export const ALLERGEN_STATEMENT = 'allergen-statement';
export const PRIVACY_POLICY = 'privacy-policy';
export const RESET_PASSWORD = 'reset-password';
export const RESET_PASSWORD_CONFIRMATION = 'reset-password-confirmation';
export const CLICKCOLLECT_PURCHASE_HISTORY = 'clickcollect-purchase-history';
export const CLICKCOLLECT_PURCHASE_HISTORY_TABS = 'app/clickcollect-purchase-history';
export const CLICKCOLLECT_DETAILS = 'app/clickcollect-details';
export const APP_SETTINGS = 'app-settings';
export const APP_SETTINGS_TABS = 'app/app-settings';

